import { shipmentStatuses } from '@reveni-io/reveni-ui'

import { claimStatusValues } from '@/common/constants'
import { getParcelTypeKey } from '@/parcels/helpers/helpers'

import { parcelCardTypeInfo } from './constants'

export const getParcelCardTypeInfo = parcel => {
  return parcelCardTypeInfo[getParcelTypeKey(parcel.type, parcel.is_exchange)]
}

export const isCancelledParcel = parcel => parcel.status === shipmentStatuses.cancelled

export const getCountLabelKey = (count, labelKeys) => (count === 1 ? labelKeys.singular : labelKeys.plural)

export const hasPendingAlerts = parcel => !isCancelledParcel(parcel) && parcel.pending_alerts_count > 0

export const hasActiveClaim = parcel => {
  return !isCancelledParcel(parcel) && Object.values(claimStatusValues).includes(parcel.active_claim?.status)
}

export const getFormattedCreatedAt = (createdAt, language, storeTimeZone) => {
  const date = new Date(createdAt)
  const timeZone = storeTimeZone || undefined

  const formattedDate = new Intl.DateTimeFormat(language, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone,
  }).format(date)
  const formattedTime = new Intl.DateTimeFormat(language, {
    hour: 'numeric',
    minute: '2-digit',
    timeZone,
  }).format(date)

  return `${formattedDate} · ${formattedTime}`
}
